import React from 'react'
import { Card, Text, Box, Group, ThemeIcon } from '@mantine/core'
import { currencyFormat } from 'simple-currency-format'

const BoxSummary = ({ title, value, icon, currency = false }) =>
{
  const formattedValue = currency && typeof value === 'number' 
    ? currencyFormat(value, 'es-MX', 'MXN', 0) 
    : value;

  return (
    <Card 
      withBorder 
      padding="sm" 
      radius="xs" 
      shadow="xs"
      style={{ borderLeft: '3px solid var(--mantine-color-yellow-filled)' }}
    >
      <Group justify="space-between" mb="xs">
        <Text size="xs" fw={700} tt="uppercase" c="dimmed">{ title }</Text>
        <ThemeIcon variant="light" color="yellow" size="sm" radius="xs">
          { icon }
        </ThemeIcon>
      </Group>

      <Box>
        { value !== null && value !== undefined ? (
          <Text 
            size="xl" 
            fw={700} 
            style={{ 
              fontFamily: 'var(--mantine-font-family-monospace)',
              letterSpacing: '-0.5px'
            }}
          >
            { formattedValue }
          </Text>
        ) : (
          <Text size="sm" c="dimmed">Cargando...</Text>
        ) }
      </Box>
    </Card>
  )
}

export default BoxSummary
